import React from "react"
import { AvField, AvGroup } from "availity-reactstrap-validation"
import { Button, Label, FormGroup, Col, Row } from "reactstrap"
import countries from "assets/files/countries.json"

const InstitutionDetails = (props) => {
  return (
    <>
      <Row>
        <Col md={6}>
          <AvGroup>
            <Label for="institution_name">Name of Institution</Label>
            <AvField
              name="institution_name"
              id="institution_name"
              required
              errorMessage="Please enter the name of the institution"
              disabled={props.disableFormFields}
              value={props.data? props.data.institution_name : ""}
            />
          </AvGroup>
        </Col>

        <Col md={6}>
          <AvGroup>
            <Label for="institution_address">Institution Address</Label>
            <AvField
              name="institution_address"
              id="institution_address"
              required
              errorMessage="Please enter the institution's address"
              disabled={props.disableFormFields}
              value={props.data? props.data.institution_address : ""}
            />
          </AvGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <AvGroup>
            <Label for="institution_phone">Institution Phone</Label>
            <AvField
              name="institution_phone"
              id="institution_phone"
              type="text"
              required
              errorMessage="Please enter a valid phone number"
              disabled={props.disableFormFields}
              value={props.data? props.data.institution_phone : ""}
            />
          </AvGroup>
        </Col>
        <Col md={6}>
          <AvGroup>
            <Label for="institution_email">Institution Email</Label>
            <AvField
              name="institution_email"
              id="institution_email"
              type="email"
              required
              errorMessage="Please enter a valid email address"
              disabled={props.disableFormFields}
              value={props.data? props.data.institution_email : ""}
            />
          </AvGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <AvGroup>
            <Label for="representative_phone">Representative Phone</Label>
            <AvField
              name="representative_phone"
              id="representative_phone"
              type="text"
              required
              errorMessage="Please enter a valid phone number"
              disabled={props.disableFormFields}
              value={props.data? props.data.representative_phone : ""}
            />
          </AvGroup>
        </Col>
        <Col md={6}>
          <AvGroup>
            <Label for="representative_email">Representative Email</Label>
            <AvField
              name="representative_email"
              id="representative_email"
              type="email"
              required
              errorMessage="Please enter a valid email address"
              disabled={props.disableFormFields}
              value={props.data? props.data.representative_email : ""}
            />
          </AvGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <AvGroup>
            <Label for="representative_name">Contact Person Name</Label>
            <AvField
              name="representative_name"
              id="representative_name"
              required
              errorMessage="Please enter the contact person's name"
              disabled={props.disableFormFields}
              value={props.data? props.data.representative_name : ""}
            />
          </AvGroup>
        </Col>

        {/* <Col md={6}>
          <AvField
            type="select"
            name="nationality"
            label="Select Nationality"
            required
            disabled={props.disableFormFields}
            value={props.data? props.data.nationality : ""}
          >
            <option>----Select Nationality----</option>
            {countries.map((country, key) => (
              <option key={key} value={country.name}>{country.name}</option>
            ))}
          </AvField>
        </Col> */}
      </Row>
      <br></br>
    </>
  )
}

export default InstitutionDetails
